/**
 * ## Size selector
 *
 * @module src/components/size
 */

"use strict";

const conf = require("../../config");
const l = require("../../common").localization;

/**
 * Size display.
 */
const create = (options, data, callback) => {
  let thisHTML = '<div id="size_shell">';
  if (options.limit) {
    for (let i = 1; i <= options.limit; ++i) {
      thisHTML += `<div class="size_select" id="size${i}" data-size="${i}">${i}</div>`;
    }
    for (let i = options.limit + 1; i <= 10; ++i) {
      thisHTML += `<div class="size_select_inactive" id="size${i}" \
                data-size="${i}">${i}</div>`;
    }
  } else {
    for (let i = 1; i <= 10; ++i) {
      thisHTML += `<div class="size_select" id="size${i}" data-size="${i}">${i}</div>`;
    }
  }
  thisHTML += `<div id="size_select_more">${l.translate("More")}</div>`;
  thisHTML += "</div>";
  $(`#${options.target_id}`).html(thisHTML);
  $(".size_select").off();
  $(".size_select").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    callback(null, $(`#${e.target.id}`).data("size"));
    $(".size_select").css("background", "#444");
    $(`#${e.target.id}`).css("background", "#aaa");
    destroy();
  });
  $("#size_select_more").off();
  $("#size_select_more").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    createAlt(options, data, callback);
  });
};

const createAlt = (options, data, callback) => {
  let thisHTML = '<div id="size_shell">';
  if (options.entry) {
    options.targetResult = "accordion_size";
    thisHTML +=
      '<input type="text" id="accordion_size" class="size_entry" readonly>';
  }
  for (let i = 1; i <= 9; ++i) {
    thisHTML += `<div class="size_select_alt" id="size_alt${i}" data-size="${i}">${i}</div>`;
  }
  thisHTML += '<div class="size_select_alt_blank"></div>';
  thisHTML +=
    '<div class="size_select_alt" id="size_alt0" data-size="0">0</div>';
  thisHTML += `<div id="size_select_alt_done">${l.translate("Done")}</div>`;
  thisHTML += "</div>";
  $(`#${options.target_id}`).html(thisHTML);
  $(`#${options.targetResult}`).val("");
  $(".size_select_alt").off();
  $(".size_select_alt").fastClick((e) => {
    e.stopPropagation();
    TweenMax.to($(`#${e.target.id}`), 0, {
      alpha: 0.5,
      ease: Power2.easeIn,
    });
    TweenMax.to($(`#${e.target.id}`), conf.vars.interfaceSpeed / 2, {
      alpha: 1,
      ease: Power2.easeIn,
    });
    $(`#${options.targetResult}`).val(
      $(`#${options.targetResult}`).val() + $(`#${e.target.id}`).data("size")
    );
  });
  $(".size_select_alt_done").off();
  $("#size_select_alt_done").fastClick((e) => {
    e.stopPropagation();
    if ($(`#${options.targetResult}`).val() === "") {
      create(options, data, callback);
    } else {
      callback(null, parseInt($(`#${options.targetResult}`).val(), 10));
      destroy();
    }
  });
};

const destroy = () => {
  $("#component_catch").css("display", "none");
};

module.exports = {
  create,
  destroy,
};



/** WEBPACK FOOTER **
 ** ./src/components/size/index.js
 **/